import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "consent-banner",
  role: "dialog",
  "aria-live": "polite",
  "aria-label": "Cookies"
}
const _hoisted_2 = { class: "consent-card" }
const _hoisted_3 = { class: "consent-links" }
const _hoisted_4 = { class: "consent-actions" }

import { onBeforeUnmount, onMounted, ref } from 'vue';

import { analytics } from '@/lib/analytics';
import { readConsent, setConsent, withdrawConsent } from '@/shared/lib/consent';


export default /*@__PURE__*/_defineComponent({
  __name: 'AnalyticsConsentBanner',
  setup(__props) {

const isVisible = ref(false);

const syncVisibility = () => {
    isVisible.value = readConsent() === 'unknown';
};

const acceptAnalytics = () => {
    setConsent('granted', { source: 'banner' });
    isVisible.value = false;
    analytics.trackPageView(window.location.href);
};

const declineAnalytics = () => {
    setConsent('denied', { source: 'banner' });
    withdrawConsent();
    isVisible.value = false;
};

const onStorageChange = (event: StorageEvent) => {
    if (!event.key || event.key.includes('consent')) {
        syncVisibility();
    }
};

const onConsentChange = () => {
    syncVisibility();
};

onMounted(() => {
    syncVisibility();
    window.addEventListener('storage', onStorageChange);
    window.addEventListener('analytics-consent-changed', onConsentChange);
});

onBeforeUnmount(() => {
    window.removeEventListener('storage', onStorageChange);
    window.removeEventListener('analytics-consent-changed', onConsentChange);
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_Transition, { name: "consent-fade" }, {
    default: _withCtx(() => [
      (isVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "consent-title" }, "Cookies", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "consent-text" }, " Необходимые cookies - для работы сервиса. Аналитические - только с вашего согласия. ", -1)),
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "consent-subtext" }, "Выбор можно изменить в настройках.", -1)),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_RouterLink, {
                  to: "/legal/privacy-policy",
                  class: "consent-link"
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode(" Политика cookies и конфиденциальности ")
                  ])),
                  _: 1
                })
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "consent-meta" }, "Только необходимые cookies включены всегда", -1)),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  class: "consent-btn consent-btn-secondary",
                  onClick: declineAnalytics
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode(" Не принимаю ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "flat",
                  class: "consent-btn consent-btn-primary",
                  onClick: acceptAnalytics
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" Принимаю ")
                  ])),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})